export default "__VITE_PUBLIC_ASSET__583184c2__"